import { useEffect, useReducer, useState } from 'react';
import style from './user-post-list.module.scss';
import { useNavigate } from 'react-router-dom';
import { TArticle } from '../../../models/common';
import dbService from '../../../services/database.service';
import helperService from '../../../services/helper.service';
import UserPostsSkeleton from '../../organisms/user-posts-skeleton/user-posts-skeleton';
import { WArticle } from '../article/article';
import NoContent from 'components/molecules/no-content/no-content';
import useArticle from 'custom-hooks/useArticle';

function UserPost({ userId, handleClose }: { userId: string; handleClose?: Function }) {
  const { articles, setArticles, deleteArticle } = useArticle();
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const [loading, setLoading] = useState(true);
  const navigation = useNavigate();

  useEffect(() => {
    setLoading(true);
    dbService
      .getArticles({
        relation: true,
        filter: {
          publisher: userId,
        },
        sort: { _id: -1 }
      })
      .then((res) => setArticles(res))
      .finally(() => setLoading(false));
  }, []);

  const handleClickArticle = (post: TArticle) => {
    navigation(helperService.getNavigateLink(post));
    handleClose && handleClose();
  };

  const handleDeleteArticle = (id: string) => {
    deleteArticle(id).then(() => forceUpdate());
  };

  if (loading) {
    return <UserPostsSkeleton />;
  }

  if (!articles.length) {
    return (
      <NoContent
        title="There are no posts yet"
        subTitle="Posts by this member will show up here."
      />
    );
  }

  return (
    <div className={style.postCards}>
      {articles.map((article, index) => (
        <div onClick={() => handleClickArticle(article)} key={article._id}>
          <WArticle
            onDelete={handleDeleteArticle}
            data={article}
            key={article._id}
            type={'content'}
            typeContentClass={style.userPost}
          />
        </div>
      ))}
    </div>
  );
}

export default UserPost;
